import React from 'react';

import Conversation from 'models/conversation';
import ConversationTopicsContainer from 'components/customer/conversation_history/topics/conversation_topics_container';
import CustomerContext from 'components/customer/customer_context';

export function ConversationTopics() {
  return (
    <CustomerContext.Consumer>
      {({ customerId, latestConversationId, latestConversationStatus }) => {
        if (!latestConversationId || latestConversationStatus === Conversation.Status.CLOSED) {
          return null;
        }

        return <ConversationTopicsContainer conversationId={latestConversationId} customerId={customerId} />;
      }}
    </CustomerContext.Consumer>
  );
}

export default ConversationTopics;
